import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Event, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/takeUntil';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'bouncyCoin';
  isHeader: boolean = false;
  isFooter: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.router.events
      .filter((event: Event) => event instanceof NavigationEnd)
      .takeUntil(componentDestroyed(this))
      .subscribe((event: any) => {
        let currentRoute = this.route.root;
        while (currentRoute.children[0] !== undefined) {
          currentRoute = currentRoute.children[0];
        }
        const stateName = currentRoute.snapshot.routeConfig.path;
        const params = currentRoute.snapshot.queryParams;
        const url = event.url.replace('/', '');
        if (url === 'login' || url == 'register' || url === 'forgot-password') {
          this.isHeader = false;
          this.isFooter = false;
        } else {
          this.isHeader = true;
          this.isFooter = true;
        }
      });
  }

  ngOnDestroy() { }
}
